import React, {
  useEffect, useState, Fragment, useMemo,
} from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Popconfirm, Dropdown, Checkbox, Select, Tag, Switch, Tooltip, notification, Modal, Radio, Space, Popover, Drawer,
  Divider,
} from 'antd';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight, faDownload } from '@fortawesome/free-solid-svg-icons';
import {
  FilterOutlined, ControlOutlined, UpCircleTwoTone, ExclamationCircleFilled, FileProtectOutlined, LoadingOutlined, CopyOutlined,
} from '@ant-design/icons';
import Busy from '@Images/admin/integrations/busy.png';
import BulkInvoiceActions from '@Components/Sales/Invoice/InvoiceList/BulkActions';
import H3Text from '@Uilib/h3Text';
import InvoiceActions from '@Actions/invoiceActions';
import ZohoIntegrationActions from '@Actions/integrations/zohoIntegrationActions';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import ShopifyIcon from '@Images/admin/integrations/shopify-icon.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { toISTDate } from '@Apis/constants';
import UnicommerceIntegrationActions from '@Actions/integrations/unicommerceIntegrationActions';
import ucIcon from '@Images/icons/unicommerce-icon.png';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import H3DateSelector from '@Uilib/h3DateSelector';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import ZohoBooks from '@Images/admin/integrations/zoho-books.png';
import SelectDepartment from '@Components/Common/SelectDepartment';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import TallyPrime from '@Images/admin/integrations/tally-prime.png';
import CustomStatusActions from '@Actions/configurations/customStatusActions';
import TagSelector from '@Components/Common/Selector/TagSelector';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TdsTcsForm from '@Components/Admin/AdminConfiguration/Gst/TdsTcs/TdsTcsForm';
// import BulkReturns from '@Components/Sales/Invoice/InvoiceList/BulkReturns';
import BulkReturns from '@Components/Sales/Invoice/InvoiceList/BulkReturns';
import SelectUser from '@Components/Common/SelectUser';
import TenantActions from '@Actions/tenantActions';
import SelectStatus from '../../../Common/SelectCustomStatus';
import BusyIntegrationActions from '../../../../actions/integrations/busyIntegrationAction';
import documentUINamesConstant from '../../../../apis/documentUINamesConstant';
import HideValue from '../../../Common/RestrictedAccess/HideValue';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import ListScreenKeys from './mobileListHelper';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';
import PRZSelect from '../../../Common/UI/PRZSelect';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../../apis/constants';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';

const { Option } = Select;
/**
 *
 */
function ConsumptionList({
  invoices, getInvoiceLoading, user, getInvoice, history, syncSOLoading, syncSO, getDocCFV2Loading, getDocCFV2, getDocCFV2Success, customFieldsProps, getCustomStatus, getOrgUsers, orgUsers,
  departments, MONEY, updateInvoiceStatus, customStatusConsumption, updateInvoiceStatusLoading, downloadInvoiceListLoading, downloadInvoiceList,

}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [shopifyKeyword, setShopifyKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [shopifySearchKeyword, setShopifySearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [fixedColumns, setFixedColumns] = useState(['INVOICE_NO']);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCustomStatusId, setSelectedCustomStatusId] = useState('');
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [call, setCall] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedCustomStatus, setSelectedCustomStatus] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [source, setSource] = useState([]);
  const [stockStatus, setStockStatus] = useState([]);
  const [departmentLevelVisibility, setDepartmentLevelVisibility] = useState(false);
  const [marketplaceInvoice, setMarketplaceInvoice] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);
  const [selectedTag, setSelectedTag] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [reportType, setReportType] = useState('document_level');
  const [showBulkReturnsDrawer, setShowBulkReturnsDrawer] = useState(false);
  const [selectedAssignee, setSelectedAssignee] = useState([]);
  const [showFilters, setShowFilters] = useState(false);

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  const [selectedConsumptionOrder, setSelectedConsumptionOrder] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-consumption') ? JSON.parse(localStorage.getItem('prcz-page-columns-consumption')) : {
    CONSUMPTION_NO: {
      label: 'Consumption Order #',
      visible: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
    },
    CUSTOMER: {
      label: 'Customer',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: true,
    },
    FULFILLMENT_STATUS: {
      label: 'Fulfillment Status',
      visible: true,
    },
    LABEL: {
      label: 'Label',
      visible: true,
    },
    SALES_MANAGER: {
      label: 'Sales Manager',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
  });

  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [orderDateSelectedIntervalDateRangeType, setOrderDateSelectedIntervalDateRangeType] = useState('');

  const colorArray = ['blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple', 'blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple'];

  const getInvoiceColumns = () => {
    const tableColumns = [
      // {
      //   title: '',
      //   render: (record) => (
      //     <Link to={`/sales/invoice/view/${record?.invoice_id}`}>
      //       <div className="mobile-list__item">
      //         <div style={{ display: 'flex' }}>
      //           <H3Text text={`#${record?.invoice_number}`} className="mobile-list__item-number" />
      //           <div className="mobile-list__item-status" style={{ backgroundColor: Helpers.getStatusColor(record?.status).color }}>
      //             {Helpers.getStatusColor(record.status).text?.toUpperCase()}
      //           </div>
      //         </div>
      //         {record?.customer_info && (
      //           <div className="mobile-list__item-info">
      //             {`Customer - ${record?.customer_info?.customer_name}`}
      //           </div>
      //         )}
      //         {record?.order_id && <H3Text text={`Order Number - ${record?.sales_order_number}`} className="mobile-list__item-info" />}
      //         <H3Text text={`Invoice Total - ${MONEY(((record?.invoice_grand_total || '0'), record?.org_currency_info?.currency_code), record?.org_currency_info?.currency_code)}`} className="mobile-list__item-info" />
      //         <H3Text text={`Created by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer" />
      //       </div>
      //     </Link>
      //   ),
      //   responsive: ['xs'],
      // },
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <Link
                // to={`/inventory/product/view/${record?.product_sku_id}?tab=/general-information`}
                >
                  <PRZText
                    text={`#${record?.invoice_number}`}
                    className="mobile-list__card_item-number"
                  />
                </Link>
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  className="mobile-list__card__status"
                  style={{
                    backgroundColor: record?.custom_status_info?.color_code,
                  }}
                  text={record?.custom_status_info?.status_name?.replaceAll('_', ' ').toProperCase()}
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                {record?.customer_info?.customer_name ? (
                  <div className="mobile-list__card_item-name_wrapper">
                    <Tooltip
                      title={
                        Helpers.getPermission(Helpers.permissionEntities.CUSTOMER,
                          Helpers.permissionTypes.READ, user)
                          ? (
                            <Link
                            // to={`/sales/customer/view/${record?.customer_id}`} target="_blank"
                            >
                              <PRZText
                                className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                                text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                              />
                            </Link>
                          ) : (
                            <PRZText
                              className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                              text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                            />
                          )
                      }
                      color="white"
                    >
                      <PRZText text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`} className="mobile-list__card_item-name" />
                    </Tooltip>
                  </div>
                ) : '-'}

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${record?.tenant_info?.tenant_name} (${record?.tenant_department_info?.department_name})`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Location: ${record?.tenant_info?.tenant_name} (${record?.tenant_department_info?.department_name})`} className="mobile-list__card_item-details" />
                </Tooltip>

                <PRZText text={`Sales Manager: ${record?.account_manager_info?.account_manager_id ? (`${record?.account_manager_info?.first_name} ${record?.account_manager_info?.last_name}`) : 'N/A'}`} className="mobile-list__card_item-details" />

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${dayjs(record?.created_at).format('DD/MM/YYYY')} ( ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'})`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Created By ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'} on ${dayjs(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details created_by_info" />
                </Tooltip>

              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  title={(
                    <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Source" />
                  )}
                >
                  <PRZText
                    text={record?.source?.replace(/_/g, ' ')?.toProperCase()}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
              </div>
            </div>

            <Divider className="mobile-list__card_divider" />

            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <Tooltip
                  color="white"
                  title={(
                    <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Fulfillment Status" />
                  )}
                >
                  <PRZText
                    className="mobile-list__card_footer__other-status font-11"
                    style={{ color: Helpers.getStatusColor(record?.stock_status).color }}
                    text={record?.stock_status?.replaceAll('_', ' ')?.toProperCase() || '-'}
                  />
                </Tooltip>

              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedConsumptionOrder(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'CONSUMPTION ORDER #',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (record) => (
          <div className="column-number__wrapper min-width-150">
            {record?.invoice_number}
          </div>
        ),
        className: !visibleColumns?.CONSUMPTION_NO?.visible ? 'display-none' : '',
        fixed: 'left',
      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.tenant_info?.tenant_name} />
            <H3Text text={record?.tenant_department_info?.department_name} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'SOURCE',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.source?.replace(/_/g, ' ')?.toProperCase()} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SOURCE?.visible ? 'display-none' : '',
      },
      {
        title: 'CUSTOMER',
        render: (text, record) => (
          <div className="associated-entity min-width-70">
            {Helpers.getPermission(Helpers.permissionEntities.CUSTOMER,
              Helpers.permissionTypes.READ, user)
              ? (record?.customer_info?.customer_name ? (
                <Link to={`/sales/customer/view/${record?.customer_id}`} target="_blank">
                  {`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                </Link>
              ) : '-') : (`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CUSTOMER?.visible ? 'display-none' : '',
      },
      {
        title: 'SALES MANAGER',
        render: (text, record) => (
          <div className="min-width-100">
            {record?.account_manager_info?.account_manager_id ? (`${record?.account_manager_info?.first_name} ${record?.account_manager_info?.last_name}`) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SALES_MANAGER?.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED DATE',
        render: (record) => (
          <div>
            <div className="column-date min-width-85">
              {dayjs(record?.created_at).format('DD/MM/YYYY')}
            </div>
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'FULFILLMENT STATUS',
        render: (item) => (
          <div className="shopify-order-statuses min-width-130" style={{ color: Helpers.getStatusColor(item?.stock_status).color }}>
            {item?.stock_status?.replaceAll('_', ' ') || '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.FULFILLMENT_STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
      {
        title: 'LABELS',
        render: (item) => (
          <Fragment>
            <div className="table-labels__list min-width-70">
              <Space size={[0, 8]} wrap>
                {item?.tags?.map((tag, index) => (
                  <Tag
                    key={index}
                    color={colorArray[index]}
                  >
                    {tag}
                  </Tag>
                ))}
              </Space>
            </div>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LABEL?.visible ? 'display-none' : '',
      },
    ];
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customs = customFieldsProps?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.map((custom) => {
        tableColumns.push({
          title: custom.field_name?.toUpperCase(),
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record.custom_fields?.filter((subItem) => subItem.cf_id === custom.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }
    const addAlpha = (color, opacity) => {
      // coerce values so ti is between 0 and 1.
      const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return color + _opacity.toString(16)?.toUpperCase();
    };
    tableColumns.push({
      title: '',
      key: 'action',
      fixed: 'right',
      render: (record) => (
        <div className="list__actions">
          <div className="list__actions-button list__actions-status-selector">
            <SelectStatus
              selectedCustomStatus={record?.custom_status_id}
              hideTitle
              tenantId={selectedTenant?.join(',')}
              posibleStatuses={record?.possible_status ? [record?.custom_status_info, ...record?.possible_status] : [record?.custom_status_info]}
              onChange={(value) => {
                updateInvoiceStatus({
                  status: value?.type,
                  secondary_status: value?.status_name,
                  invoice_id: record?.invoice_id,
                  custom_status_id: value?.custom_status_id,
                }, () => {
                  setCall(!call);
                });
              }}
              disabled={['VOID', 'SENT_FOR_APPROVAL'].includes(record?.custom_status_info?.type) || !record?.custom_status_id}
              customStyle={{
                color: record?.custom_status_info?.color_code,
                backgroundColor: addAlpha(record?.custom_status_info?.color_code, 0.9),
                fontSize: '11px',
                height: '50px',
              }}
              dropdownAlign={{ offset: [0, 18] }}
            />
          </div>

          {!isPortrait && Helpers.getPermission(Helpers.permissionEntities.CONSUMPTION_ORDER,
            Helpers.permissionTypes.READ, user) && (
            <div
              className="list__actions-button list__actions-button-dark"
              onClick={() => {
                history.push(`/sales/consumption/view/${record?.invoice_id}`);
              }}
            >
              View
            </div>
          )}
          {/* <Tooltip
            placement="topLeft"
            title="Make a Copy"
          >
            <div
              className={`list__actions-button ${(record?.shopify_order_id || record?.unicommerce_so_code) ? 'list__actions-button-download-disabled' : ''}`}
              onClick={() => {
                if (!record?.shopify_order_id && !record?.unicommerce_so_code) {
                  history.push({
                    pathname: '/sales/consumption/create',
                    state: { cloneInv: record?.invoice_id, selectedTenantIdInv: record?.tenant_id },
                  });
                }
              }}
            >
              <CopyOutlined
                style={{
                  fontSize: '16px',
                }}
              />
            </div>
          </Tooltip> */}

        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      className: 'list__actions-column',
    });
    return tableColumns.filter((item) => !item.hidden);
  };

  useEffect(() => {
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-consumption'))?.[customField.cf_id]?.visible || false,
        };
      });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      // {
      //   filter_key: 'shopify_keyword',
      //   filter_value: (Helpers.getValueFromUrl('shopify_keyword') && decodeURIComponent(Helpers.getValueFromUrl('shopify_keyword'))) || '',
      //   filter_type: filterTypeEnums.STRING,
      // },
      // {
      //   filter_key: 'payment_status',
      //   filter_value: Helpers.getValueFromUrl('payment_status') || '',
      //   filter_type: filterTypeEnums.STRING,
      // },
      {
        filter_key: 'custom_status',
        filter_value: Helpers.getValueFromUrl('custom_status') || null,
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status_id',
        filter_value: Number(Helpers.getValueFromUrl('custom_status_id')) || null,
        filter_type: filterTypeEnums.NUMBER,
      },
      // {
      //   filter_key: 'source',
      //   filter_value: Helpers.getValueFromUrl('source') ? Helpers.getValueFromUrl('source')?.split(',')?.map((item) => item) : [],
      //   filter_type: filterTypeEnums.ARRAY,
      // },
      // {
      //   filter_key: 'stock_status',
      //   filter_value: Helpers.getValueFromUrl('stock_status') ? Helpers.getValueFromUrl('stock_status')?.split(',')?.map((item) => item) : [],
      //   filter_type: filterTypeEnums.ARRAY,
      // },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'label',
        filter_value: Helpers.getValueFromUrl('label') ? Helpers.getValueFromUrl('label')?.split(',')?.map((item) => item) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      // {
      //   filter_key: 'marketplace_invoice',
      //   filter_value: Boolean(Helpers.getValueFromUrl('marketplace_invoice')) || false,
      //   filter_type: filterTypeEnums.BOOLEAN,
      // },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'accountManager',
        filter_value: Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
          userId: parseInt(item),
          title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
          identity: parseInt(item) == 0 ? 'UA' : orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
        })) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department_id',
        filter_value: Number(Helpers.getValueFromUrl('department_id')) || '',
        filter_type: filterTypeEnums.NUMBER,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => {
    const restrictAccountManagerPermissionCheck = user?.tenant_info?.sales_config?.sub_modules?.invoice?.settings?.restrict_invoice_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_invoice);
    return [
      {
        filter_key: 'keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'limit',
        filter_value: limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      // {
      //   filter_key: 'shopify_keyword',
      //   filter_value: '',
      //   filter_type: filterTypeEnums.STRING,
      // },
      // {
      //   filter_key: 'payment_status',
      //   filter_value: '',
      //   filter_type: filterTypeEnums.STRING,
      // },
      {
        filter_key: 'custom_status',
        filter_value: null,
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status_id',
        filter_value: null,
        filter_type: filterTypeEnums.STRING,
      },
      // {
      //   filter_key: 'source',
      //   filter_value: [],
      //   filter_type: filterTypeEnums.ARRAY,
      // },
      // {
      //   filter_key: 'stock_status',
      //   filter_value: [],
      //   filter_type: filterTypeEnums.ARRAY,
      // },
      {
        filter_key: 'tenant',
        filter_value: [user?.tenant_info?.tenant_id],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'label',
        filter_value: [],
        filter_type: filterTypeEnums.ARRAY,
      },
      // {
      //   filter_key: 'marketplace_invoice',
      //   filter_value: false,
      //   filter_type: filterTypeEnums.BOOLEAN,
      // },
      {
        filter_key: 'startDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'endDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'accountManager',
        filter_value: restrictAccountManagerPermissionCheck ? [{
          userId: user?.user_id,
          title: `${user?.first_name} ${user?.last_name}`?.trim(),
          identity: user?.first_name?.substring(0, 2).toUpperCase(),
        }] : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department_id',
        filter_value: Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility ? Number(Helpers.getDepartmentId(user)) : '',
        filter_type: filterTypeEnums.NUMBER,
      },
    ];
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.CONSUMPTION_ORDER,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  const pushParamsToUrl = (page, currentLimit, word, status, paymentStatuses, currentTenant, currentStartDate, currentEndDate, currentDepartment, customStatus, customStatusId, shopifyWord, selectedMarketplaceInvoice, tags, accountManager, createdFrom, selectedStockStatus, orderDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    url += '&list_screen=true';
    if (currentLimit) url += `&limit=${currentLimit}`;
    if (word) url += `&keyword=${word}`;
    // if (shopifyWord) url += `&shopify_keyword=${encodeURIComponent(shopifyWord)}`;
    if (status) url += `&status=${status}`;
    if (customStatus) url += `&custom_status=${customStatus}`;
    if (customStatusId) url += `&custom_status_id=${customStatusId}`;
    // if (paymentStatuses) url += `&payment_status=${paymentStatuses}`;
    if (currentTenant.length > 0) url += `&tenant=${currentTenant}`;
    if (currentStartDate) url += `&startDate=${currentStartDate}`;
    if (currentEndDate) url += `&endDate=${currentEndDate}`;
    if (orderDateSelectedIntervalDateRangeType) url += `&order_date_type=${orderDateSelectedIntervalDateRangeType}`;
    if (currentDepartment) url += `&department_id=${currentDepartment}`;
    // if (selectedMarketplaceInvoice) url += `&marketplace_invoice=${selectedMarketplaceInvoice}`;
    // if (createdFrom) url += `&source=${createdFrom}`;
    // if (selectedStockStatus) url += `&stock_status=${selectedStockStatus}`;
    if (tags.length > 0) url += `&label=${tags}`;
    if (accountManager.length > 0) url += `&accountManager=${selectedAssignee?.map((item) => (item?.userId))?.join(',')}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }
        filterValue.orderDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setSelectedEmails([user?.email]);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        // setShopifySearchKeyword(tempFilterValues.shopify_keyword);
        setKeyword(tempFilterValues.keyword);
        // setPaymentStatus(tempFilterValues.payment_status);
        setSelectedCustomStatus(tempFilterValues.custom_status);
        setSelectedCustomStatusId(tempFilterValues.custom_status_id);
        // setShopifyKeyword(tempFilterValues.shopify_keyword);
        // setSource(tempFilterValues.source);
        // setStockStatus(tempFilterValues.stock_status);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedTag(tempFilterValues.label);
        // setMarketplaceInvoice(tempFilterValues.marketplace_invoice);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
        setSelectedAssignee(tempFilterValues.accountManager);
        setSelectedDepartment(tempFilterValues.department_id);

        if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
          setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
          // setSelectedDepartment(tempFilterValues.department_id || null || Helpers.getDepartmentId(user)?.toString());
        } else {
          // setSelectedDepartment(tempFilterValues.department_id || null);
        }

        // if (user?.tenant_info?.sales_config?.sub_modules?.invoice?.settings?.restrict_invoice_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_invoice)) {
        //   setSelectedAssignee([{
        //     userId: user?.user_id,
        //     title: `${user?.first_name} ${user?.last_name}`?.trim(),
        //     identity: user?.first_name?.substring(0, 2).toUpperCase(),
        //   }]);
        // } else {
        //   setSelectedAssignee(tempFilterValues.accountManager || []);
        // }
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      getOrgUsers(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ)?.join(','), (orgUsersData) => {
        // setSelectedAssignee(Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
        //   userId: parseInt(item),
        //   title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
        //   identity: parseInt(item) == 0 ? 'UA' : orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
        // })) : []);
      });
      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setLimit(Helpers.getValueFromUrl('limit') || limit);
      // setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      // setShopifySearchKeyword(Helpers.getValueFromUrl('shopify_keyword') && decodeURIComponent(Helpers.getValueFromUrl('shopify_keyword')));
      // setKeyword(Helpers.getValueFromUrl('keyword'));
      // setPaymentStatus(Helpers.getValueFromUrl('payment_status'));
      // // setSelectedStatus(Helpers.getValueFromUrl('status'));
      // setSelectedCustomStatus(Helpers.getValueFromUrl('custom_status'));
      // setSelectedCustomStatusId(Number(Helpers.getValueFromUrl('custom_status_id')) || '');
      // setShopifyKeyword(Helpers.getValueFromUrl('shopify_keyword') && decodeURIComponent(Helpers.getValueFromUrl('shopify_keyword')));
      // // setSelectedStatus(Helpers.getValueFromUrl('status'));
      // setSelectedEmails([user?.email]);
      // // setSource(Helpers.getValueFromUrl('source'));
      // setSource(Helpers.getValueFromUrl('source') ? Helpers.getValueFromUrl('source')?.split(',')?.map((item) => item) : []);
      // setStockStatus(Helpers.getValueFromUrl('stock_status') ? Helpers.getValueFromUrl('stock_status')?.split(',')?.map((item) => item) : []);
      // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [user?.tenant_info?.tenant_id]);
      // setSelectedTag(Helpers.getValueFromUrl('label') ? Helpers.getValueFromUrl('label')?.split(',')?.map((item) => item) : []);
      // setMarketplaceInvoice(Helpers.getValueFromUrl('marketplace_invoice') || false);
      // setStartDate(Number(Helpers.getValueFromUrl('startDate')));
      // setEndDate(Number(Helpers.getValueFromUrl('endDate')));
      // setSelectedAssignee(Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
      //   userId: parseInt(item),
      //   title: `${orgUsers?.data?.find((i) => item?.user_id === parseInt(item))?.first_name}`?.trim(),
      //   identity: orgUsers?.data?.find((i) => item?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
      // })) : []);
      // if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
      //   setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
      //   setSelectedDepartment(Helpers.getValueFromUrl('department_id') || Helpers.getDepartmentId(user)?.toString());
      // } else {
      //   setSelectedDepartment(Helpers.getValueFromUrl('department_id'));
      // }
      // setIsUserReady(true);
    }

    // if (user?.tenant_info?.sales_config?.sub_modules?.invoice?.settings?.restrict_invoice_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_invoice)) {
    //   setSelectedAssignee([{
    //     userId: user?.user_id,
    //     title: `${user?.first_name} ${user?.last_name}`?.trim(),
    //     identity: user?.first_name?.substring(0, 2).toUpperCase(),
    //   }]);
    // } else {
    //   setSelectedAssignee([]);
    // }

    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (isUserReady) {
      getCustomStatus({
        entityName: 'CONSUMPTION_ORDER',
        orgId: user?.tenant_info?.org_id,
      }, () => { });
      pushParamsToUrl(currentPage, limit, searchKeyword, selectedStatus, paymentStatus, selectedTenant, startDate, endDate, selectedDepartment, selectedCustomStatus, selectedCustomStatusId, shopifySearchKeyword && shopifySearchKeyword.replace(/\s/g, ''), marketplaceInvoice, selectedTag, selectedAssignee, source, stockStatus, orderDateSelectedIntervalDateRangeType, selectedFilterView);
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: 'CONSUMPTION_ORDER',
      };
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getDocCFV2(payload);
      getInvoice(user?.tenant_info?.org_id, selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ)?.join(','), '', Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), '', Helpers.getValueFromUrl('keyword'),
        Helpers.getValueFromUrl('status'),
        Helpers.getValueFromUrl('startDate'), Helpers.getValueFromUrl('endDate'), Helpers.getValueFromUrl('department_id'), Helpers.getValueFromUrl('list_screen'), Helpers.getValueFromUrl('payment_status'), '', Helpers.getValueFromUrl('custom_status'), Helpers.getValueFromUrl('shopify_keyword') && encodeURIComponent(Helpers.getValueFromUrl('shopify_keyword')), Helpers.getValueFromUrl('label'), () => {
          setIsModalOpen(false);
        }, Helpers.getValueFromUrl('marketplace_invoice') || false, Helpers.getValueFromUrl('accountManager'), Helpers.getValueFromUrl('source'), Helpers.getValueFromUrl('stock_status'), null, null, 'CONSUMPTION_ORDER');
    }
  }, [searchKeyword, currentPage, selectedStatus, paymentStatus, selectedTenant, selectedDepartment, startDate, endDate, selectedCustomStatus, shopifySearchKeyword, limit, call, marketplaceInvoice, selectedTag, selectedAssignee, source, stockStatus, orderDateSelectedIntervalDateRangeType,
    // selectedFilterView
  ]);

  const getDataSource = (data) => {
    if (data) {
      const copyData = JSON.parse(JSON.stringify(data));
      return copyData?.map((item) => ({ ...item, key: item?.invoice_id }));
    }
    return [];
  };

  const downloadHandler = () => {
    const visibleColumnKeys = Object.entries(visibleColumns)
      .filter(([key, value]) => value.visible)
      .map(([key]) => key.toLowerCase())
      .join(',');
    const numbersArray = [];
    const stringsArray = [];
    const dataList = visibleColumnKeys.split(',');
    dataList.forEach((item) => {
      if (!isNaN(item)) {
        numbersArray.push(Number(item));
      } else {
        stringsArray.push(item);
      }
    });

    const numbersString = numbersArray.join(',');
    const stringsString = stringsArray.join(',');
    const payload = {
      tenant_ids: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ)?.join(','),
      search_keyword: Helpers.getValueFromUrl('keyword'),
      payment_status: Helpers.getValueFromUrl('payment_status'),
      from_date: Helpers.getValueFromUrl('startDate'),
      to_date: Helpers.getValueFromUrl('endDate'),
      columns: stringsString,
      custom_fields: numbersString,
      emails: selectedEmails,
      type: 'send_email',
      level: reportType,
      tags: Helpers.getValueFromUrl('label'),
      fulfillment_status: Helpers.getValueFromUrl('fulfillment_status'),
      custom_status: Helpers.getValueFromUrl('custom_status'),
      department_id: Helpers.getValueFromUrl('department_id'),
      user_id: user?.user_id,
    };
    if (!downloadInvoiceListLoading) {
      downloadInvoiceList(payload, () => {
        setOpenPopover(false);
      });
    }
  };

  return (
    <Fragment>
      <Modal
        title={(
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              alt="shopify icon"
              src={ShopifyIcon}
              width={24}
              height={24}
              style={{ marginRight: 10 }}
            />
            <div>Search for Shopify Order</div>
          </div>
        )}
        getContainer={() => document.querySelector('.trigger-modal-btn')}
        style={{
          top: '17px',
          left: '6%',
          width: '520px',
        }}
        open={isModalOpen}
        onOk={() => {
          setIsModalOpen(false);
          setShopifyKeyword(null);
          setShopifySearchKeyword(null);
        }}
        onCancel={() => {
          setIsModalOpen(false);
          setShopifyKeyword(null);
          setShopifySearchKeyword(null);
        }}
        footer={null}
        mask
        maskClosable
        closeIcon={null}
      >
        <div className="section-search">
          <div className="section-search-bar__wrapper" style={{ width: '100%' }}>
            <div className="section-search-bar">
              <input
                value={shopifyKeyword}
                placeholder="Search by comma seprated Shopify Order Id... eg.#1135,#1146"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setShopifySearchKeyword(e.target.value);
                    setCurrentPage(1);
                  }
                }}
                onChange={(event) => {
                  setShopifyKeyword(event.target.value);
                }}
              />
              {!getInvoiceLoading ? (
                <H3Image
                  src={searchIcon}
                  className="section-search-bar__icon"
                  alt="search"
                  onClick={() => {
                    setShopifySearchKeyword(keyword);
                    setCurrentPage(1);
                  }}
                />
              ) : (
                <LoadingOutlined />
              )}
            </div>
          </div>
        </div>
      </Modal>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for Consumption Order..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.INVOICE,
                  Helpers.permissionTypes.CREATE, user) && (
                  <div className="doc-list__buttons-wrapper">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Consumption Order"
                      onClick={() => {
                        history.push('/sales/consumption/create');
                      }}
                      customClass="add-button"
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                    let _orderStartDate = '';
                    let _orderEndDate = '';

                    if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                      // No action needed for empty or custom date range type
                    } else {
                      const date = dateRangePresetsValues(_orderDateRangeType);
                      const [start, end] = date;

                      _orderStartDate = start;
                      _orderEndDate = end;
                      filterValue.startDate = _orderStartDate;
                      filterValue.endDate = _orderEndDate;
                    }

                    filterValue.orderDateRangeType = _orderDateRangeType;

                    const tempFilterValues = filterValue;

                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    // setShopifySearchKeyword(tempFilterValues.shopify_keyword);
                    setKeyword(tempFilterValues.keyword);
                    // setPaymentStatus(tempFilterValues.payment_status);
                    setSelectedCustomStatus(tempFilterValues.custom_status);
                    setSelectedCustomStatusId(tempFilterValues.custom_status_id);
                    // setShopifyKeyword(tempFilterValues.shopify_keyword);
                    // setSource(tempFilterValues.source);
                    // setStockStatus(tempFilterValues.stock_status);
                    setSelectedTenant(tempFilterValues.tenant);
                    setSelectedTag(tempFilterValues.label);
                    // setMarketplaceInvoice(tempFilterValues.marketplace_invoice);
                    setStartDate(tempFilterValues.startDate);
                    setEndDate(tempFilterValues.endDate);
                    setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
                    setSelectedAssignee(tempFilterValues.accountManager);
                    setSelectedDepartment(tempFilterValues.department_id);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.CONSUMPTION_ORDER}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search for
                    &nbsp;
                    <span><b>{searchKeyword}</b></span>
                  </Tag>
                )}
                {selectedStatus && (
                  <Tag closable onClose={() => { setSelectedStatus(null); setCurrentPage(1); }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {selectedCustomStatus && (
                  <Tag closable onClose={() => { setSelectedCustomStatus(null); setCurrentPage(1); }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedCustomStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {paymentStatus && (
                  <Tag closable onClose={() => { setPaymentStatus(null); setCurrentPage(1); }} color="#2d7df7">
                    Payment Status -
                    &nbsp;
                    <span><b>{paymentStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {selectedTenant && selectedTenant?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant?.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}

                {selectedTag && selectedTag?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTag(selectedTag?.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Label -
                    &nbsp;
                    <span>
                      <b>{item?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {
                  (startDate && endDate) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setStartDate(null);
                        setEndDate(null);
                        setOrderDateSelectedIntervalDateRangeType('');
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      From:
                      &nbsp;
                      <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                      &nbsp;
                      To:
                      &nbsp;
                      <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : ''
                }
                {!!selectedDepartment && (
                  <Tag closable={!departmentLevelVisibility} onClose={() => { setSelectedDepartment(null); setCurrentPage(1); }} color="#2d7df7">
                    {' '}
                    Department -
                    &nbsp;
                    <span><b>{departments?.data?.result?.departments?.find((item) => Number(item?.department_id) === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                  </Tag>
                )}
              </div>
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${(invoices && invoices?.data?.count) ? invoices?.data?.count : '0'} Total Consumption Orders`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <div className="select-user__filter-wrapper">
                          <SelectUser
                            selectedUsers={selectedAssignee}
                            onSelect={(userId) => {
                              setCurrentPage(1)
                              setSelectedAssignee([...selectedAssignee, {
                                userId,
                                title: userId === 0 ? 'Unassigned' : `${orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name}`?.trim(),
                                identity: userId === 0 ? 'UA' : orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name?.substring(0, 2).toUpperCase(),
                              }]);
                            }}
                            onRemove={(userId) => {
                              setSelectedAssignee([...selectedAssignee?.filter((item) => item?.userId !== userId)]);
                            }}
                            disabled={user?.tenant_info?.sales_config?.sub_modules?.invoice?.settings?.restrict_invoice_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_invoice)}
                          />
                        </div>
                        {selectedRowKeys?.length > 0 && (
                          <BulkInvoiceActions
                            selectedCustomStatus={selectedCustomStatus}
                            selectedCustomStatusId={selectedCustomStatusId}
                            setSelectedCustomStatusId={(val) => setSelectedCustomStatusId(val)}
                            selectedRowKeys={selectedRowKeys}
                            selectedRows={selectedRows}
                            callback={() => {
                              setSelectedRowKeys([]);
                              setSelectedRows([]);
                              setCall(!call);
                            }}
                          />
                        )}
                        <H3DateSelector
                          selectedInterval={orderDateSelectedIntervalDateRangeType}
                          startDate={startDate}
                          endDate={endDate}
                          onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                            setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                            setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                            setCurrentPage(1);
                            setOrderDateSelectedIntervalDateRangeType(dateRangeType);
                          }}
                        />
                      </div>
                      <div className="doc-list__action-buttons">
                        <div className="action-button" onClick={() => setShowFilters(true)}>
                          <H3Text text="Filters" className="action-button-text" />
                          <FilterOutlined />
                        </div>
                      </div>
                      <Dropdown
                        overlay={(
                          <div className="custom-columns__content">
                            <div className="custom-columns__content-section">
                              <H3Text text="Visible Columns" className="custom-columns__content-title" />
                              {
                                Object.keys(visibleColumns)?.filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                  <div key={key}>
                                    <Checkbox
                                      disabled={fixedColumns.includes(key)}
                                      checked={visibleColumns[key]?.visible}
                                      onChange={() => {
                                        const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                        visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                        localStorage.setItem('prcz-page-columns-consumption', JSON.stringify(visibleColumnsCopy));
                                        setVisibleColumns(visibleColumnsCopy);
                                      }}
                                    >
                                      {visibleColumns[key]?.label}
                                    </Checkbox>
                                  </div>
                                ))
                              }
                            </div>
                            {Object.keys(visibleColumns)?.filter((item) => !visibleColumns[item]?.visible)?.length ? (
                              <div className="custom-columns__content-section">
                                <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns)?.filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                          localStorage.setItem('prcz-page-columns-consumption', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                            ) : ''}
                          </div>
                        )}
                        trigger={['click']}
                        placement="bottomRight"
                      >
                        <div className="custom-columns__wrapper">
                          Customize Columns
                          <ControlOutlined />
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                )}
                loading={getInvoiceLoading || syncSOLoading || getDocCFV2Loading || updateInvoiceStatusLoading || savedFilterViewsLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && !!getDataSource(invoices?.data?.invoices)?.length ? { x: 'max-content', y: 'calc(100dvh - 160px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && !!getDataSource(invoices?.data?.invoices)?.length}
                columns={getInvoiceColumns()}
                dataSource={getDataSource(invoices?.data?.invoices) || []}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: invoices ? invoices?.data?.count : 0,
                    pageSize: limit,
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '25', '50', '100'],
                  }
                }
                // rowSelection={(window.screen.width > 425) ? {
                //   onChange: (rowKeys, rows) => {
                //     setSelectedRowKeys(rowKeys);
                //     setSelectedRows(rows);
                //   },
                //   selectedRowKeys,
                // } : false}
                bordered
              />
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showBulkReturnsDrawer}
        width="460px"
        mask
        onClose={() => setShowBulkReturnsDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '415px' }}>
            <H3Text text="Create Bulk Returns" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowBulkReturnsDrawer(false)} />
          </div>
        </div>
        <BulkReturns callback={() => {
          history.push('/analytics/bulkUpload');
          setShowBulkReturnsDrawer(false);
        }}
        />
      </Drawer>
      <Drawer
        open={showFilters}
        width="340px"
        mask
        onClose={() => setShowFilters(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '295px' }}>
            <H3Text text="Apply Filters" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowFilters(false)} />
          </div>
        </div>
        <div className="filter-drawer__wrapper">
          <div className="filter__container">
            <div className="filter__title"> Select Business Unit </div>
            <TenantSelector
              selectedTenant={selectedTenant}
              showSearch
              isMultiple
              noDropdownAlign
              onChange={(value) => {
                setCurrentPage(1);
                setSelectedTenant(value);
              }}
              placeholder="Select Business Unit"
              hideTitle
              includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ)}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title"> Select Department </div>
            <SelectDepartment
              title="Select Department"
              hideTitle
              selectedDepartment={Number(selectedDepartment) || ''}
              noDropdownAlign
              onChange={(value) => {
                setSelectedDepartment(value?.department_id.toString() || '');
                setCurrentPage(1);
              }}
              disabled={departmentLevelVisibility}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title"> Order Status </div>
            <PRZSelect
              value={selectedCustomStatus}
              onChange={(value) => {
                const requiredStatus = customStatusConsumption?.statuses?.filter((status) => status?.status_name === value)[0];
                setSelectedCustomStatus(requiredStatus?.status_name);
                setSelectedCustomStatusId(requiredStatus?.custom_status_id);
                setSelectedRowKeys(null);
                setSelectedRows(null);
                setCurrentPage(1);
              }}
              placeholder="Order Status"
            >
              <Option key={null} value={null}> All Status</Option>
              {customStatusConsumption?.statuses?.map((item) => (<Option key={item?.custom_status_id} value={item?.status_name}>{item?.status_name?.split('_')?.join(' ')?.toProperCase()}</Option>))}
            </PRZSelect>
          </div>
          <div className="filter__container">
            <div className="filter__title"> Select Labels </div>
            <TagSelector
              filter
              entityType="INVOICE"
              selectedTags={selectedTag}
              showSearch
              showAll={false}
              noDropdownAlign
              isMultiple
              onChange={(value) => {
                setCurrentPage(1);
                setSelectedTag(value);
              }}
              placeholder="Select Label"
              hideTitle
              hideCSS
            />
          </div>
        </div>
      </Drawer>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedConsumptionOrder?.invoice_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedConsumptionOrder?.custom_fields}
          documentData={selectedConsumptionOrder}
          fields={ListScreenKeys({
            documentData: selectedConsumptionOrder,
          })}
        />
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, InvoiceReducers, UnicommerceIntegrationReducers, CFV2Reducers, DepartmentReducers, ZohoIntegrationReducers, TallyIntegrationReducers, CustomStatusReducers, TenantReducers, BusyIntegrationReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getInvoiceLoading: InvoiceReducers.getInvoiceLoading,
  invoices: InvoiceReducers.invoices,
  syncInvoiceLoading: ZohoIntegrationReducers.syncInvoiceLoading,
  syncSOLoading: UnicommerceIntegrationReducers.syncSOLoading,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  customFieldsProps: CFV2Reducers.cfV2DocInvoice,
  departments: DepartmentReducers.departments,
  syncTallyInvoiceLoading: TallyIntegrationReducers.syncTallyInvoiceLoading,
  customStatusConsumption: CustomStatusReducers.customStatusConsumption,
  downloadInvoiceLoading: InvoiceReducers.downloadInvoiceLoading,
  updateInvoiceStatusLoading: InvoiceReducers.updateInvoiceStatusLoading,
  downloadInvoiceListLoading: InvoiceReducers.downloadInvoiceListLoading,
  orgUsers: TenantReducers.orgUsers,
  pushInvoiceToBusyLoading: BusyIntegrationReducers.pushInvoiceToBusyLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getInvoice: (orgId, tenantId, invoiceId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, listScreen, paymentStatus, isEwayBilled, secondaryStatus, shopifySearchKeyword, tags, callback, isMarketplaceInvoice, accountManagerIds, source, stockStatus, excludeInvoiceIds, excludeGRNCustomerIds, invoiceType) => dispatch(InvoiceActions.getInvoice(orgId, tenantId, invoiceId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, listScreen, paymentStatus, isEwayBilled, secondaryStatus, shopifySearchKeyword, tags, callback, isMarketplaceInvoice, accountManagerIds, source, stockStatus, excludeInvoiceIds, excludeGRNCustomerIds, invoiceType)),
  syncSO: (payload, callback) => dispatch(UnicommerceIntegrationActions.syncSO(payload, callback)),
  getDocCFV2: (paylaod, callback) => dispatch(CFV2Actions.getDocCFV2(paylaod, callback)),
  getDocCFV2Success: (cf) => dispatch(CFV2Actions.getDocCFV2Success(cf)),
  updateInvoiceStatus: (payload, callback) => dispatch(InvoiceActions.updateInvoiceStatus(payload, callback)),
  downloadInvoice: (payload, callback) => dispatch(InvoiceActions.downloadInvoice(payload, callback)),
  getCustomStatus: (payload, callback) => dispatch(CustomStatusActions.getCustomStatus(payload, callback)),
  downloadInvoiceList: (payload, callback) => dispatch(InvoiceActions.downloadInvoiceList(payload, callback)),
  getOrgUsers: (tenantIds, callback) => dispatch(TenantActions.getOrgUsers(tenantIds, callback)),
});

ConsumptionList.propTypes = {
  getInvoice: PropTypes.func,
  invoices: PropTypes.any,
  user: PropTypes.any,
  getInvoiceLoading: PropTypes.bool,
  history: PropTypes.func,
  syncSOLoading: PropTypes.bool,
  syncSO: PropTypes.any,
  departments: PropTypes.any,
  customStatusConsumption: PropTypes.any,
  downloadInvoiceListLoading: PropTypes.bool,
  downloadInvoiceList: PropTypes.func,
  getOrgUsers: PropTypes.any,
  orgUsers: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ConsumptionList));
